import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LogInWithPassword from './pages/login/LogInWithPassword';
import LogInWithOtp from './pages/login/LoginWithOtp';
import Dashboard from './pages/dashboard/Dashboard';
import MumeneenTable from './pages/mumeneen/MumeneenTable';
import MumeneenDetailsTable from './pages/mumeneen/MumeneenDetailsTable';
import Payments from './pages/accounts/Payments';
import Receipts from './pages/accounts/Receipts';
import Expenses from './pages/accounts/Expenses';
import Sector from './pages/grouping/Sector';
import SubSector from './pages/grouping/SubSector';
import Transfers from './pages/grouping/Transfers';
// import Dashboard from './samples/pages/dashboard/Dashboard';
import { UserProvider } from './contexts/UserContext';
import { LicenseInfo } from '@mui/x-license-pro';
import Layout from './Layout';
import NiyazDate from './pages/bookings/NiyazDate';
import Salawat from './pages/bookings/Salawat';
import Zabihat from './pages/bookings/Zabihat';
import Fateha from './pages/bookings/Fateha';
import Feedback from './pages/feedback/Feedback';
import Notifications from './pages/notifications/Notifications';
import Settings from './pages/settings/Settings';
import UserAccess from './pages/userManagement/UserAccess'
import SignUp from './pages/signUp/SignUp';
import Roles from './pages/userManagement/Roles';
import ForgotPassword from './pages/login/ForgotPassword';
import JamaatTable from './pages/jamaat/Jamaat';
import Niyaz from './pages/niyaz/Niyaz';
import Menu from './pages/menu/Menu';
import NiyazCalendar from './pages/niyazCalendar/NiyazCalendar';
import MasoolHierarchy from './pages/masool_hierarchy/MasoolHierarchy';
import LQCollection from './pages/lqCollection/LQCollection';
import DueList from './pages/dueList/DueList';
import ZabihatPublic from './pages/zabihat/ZabihatPublic';
import PayPublic from './pages/pay/PayPublic';
import ZabihatReceipts from './pages/zabihat/ZabihatReceipts';

import ContextWrapper from './contexts/ContextWrapper';
import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
import Hierarchy from './pages/hierarchy/Hierarchy';
import Jaman from './pages/bookings/Jaman';
import SalawatFateha from './pages/bookings/SalawatFateha';
import MiqaatNiyaz from './pages/bookings/MiqaatNiyaz';
import ContributionReceipts from './pages/bookings/ContributionReceipts';

import StoreItems from './pages/store/StoreItems';
import StoreInItems from './pages/store/StoreInItems';
import StoreVendors from './pages/store/StoreVendors';
import StoreMenuDish from './pages/store/StoreMenuDish';
import StoreOutItems from './pages/store/StoreOutItems';

import './App.css'
// import MasoolHierarchy from './pages/masool_hierarchy/MasoolHierarchy';

// import SignUp from '.samples/pages/signup/SignUp';
// import Mumeneen from './samples/pages/mumeneen/Mumeneen';
// import MumeneenDetails from './samples/pages/mumeneen/MumeneenDetails';

// Set the MUI Pro license key
LicenseInfo.setLicenseKey('e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y');

function App() {
  // const [selectedSector, setSelectedSector] = useState([]);
  // const [selectedSubSector, setSelectedSubSector] = useState([]);
  // const [selectedYear, setSelectedYear] = useState([]);

  // // Handle filter changes
  // const handleFilterChange = (sector, subSector, year) => {
  //   setSelectedSector(sector);
  //   setSelectedSubSector(subSector);
  //   setSelectedYear(year);
  // };

  // const resetFilters = () => {
  //   setSelectedSector([]);
  //   setSelectedSubSector([]);
  //   setSelectedYear([]);
  // };


  return (
    <UserProvider>
      <ContextWrapper>
        <PrimeReactProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LogInWithPassword />} />
              <Route path="/login-with-otp" element={<LogInWithOtp />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/zabihat/:hashed_id" element={<ZabihatPublic />} />
              <Route path="/pay/:token" element={<PayPublic />} />
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}


              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/zabihat-dates" element={<Navigate to="/dashboard" replace />} />
                <Route path="/zabihat-receipts" element={<ZabihatReceipts />} />
                <Route path="/mumeneen" element={<MumeneenTable />} />
                <Route path="/mumeneen/:family_id" element={<MumeneenDetailsTable />} />
                <Route path="/receipts" element={<Receipts />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/sector" element={<Sector />} />
                <Route path="/sub_sector" element={<SubSector />} />
                <Route path="/transfers" element={<Transfers />} />
                <Route path="/niyaz_date" element={<NiyazDate />} />
                <Route path="/salawat_fateha" element={<SalawatFateha />} />
                <Route path="/zabihat" element={<Zabihat />} />
                {/* <Route path="/fateha" element={<Fateha />} /> */}
                <Route path="/extra_niyaz_in_faiz_thaali" element={<Jaman />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/roles" element={<Roles />} />
                <Route path="/user_access" element={<UserAccess />} />
                <Route path="/jamaat" element={<JamaatTable />} />
                <Route path="/miqaat_niyaz" element={<MiqaatNiyaz />} />
                <Route path="/contribution_receipts" element={<ContributionReceipts />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/niyaz-calendar" element={<NiyazCalendar />} />
                <Route path="/lq-collection" element={<LQCollection />} />
                <Route path="/due-list" element={<DueList />} />
                <Route path="/hierarchy" element={<Hierarchy />} />
                <Route path="/masool_hierarchy" element={<MasoolHierarchy />} />

                <Route path="/store-items" element={<StoreItems />} />
                <Route path="/store-in-items" element={<StoreInItems />} />
                <Route path="/store-out-items" element={<StoreOutItems />} />
                <Route path="/store-menu-dish" element={<StoreMenuDish />} />
                <Route path="/store-vendors" element={<StoreVendors />} />

              </Route>
              {/* Optional: Catch-all for unknown routes */}
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
          </Router>
        </PrimeReactProvider>
      </ContextWrapper>

    </UserProvider>
  );
}

export default App;
{/* <Router>
        <Routes>
          <Route path="/" element={<LogInWithPassword />} />
          <Route path="/login-with-otp" element={<LogInWithOtp />} /> */}
{/* <Route path="/sign-up" element={<SignUp />} /> */ }
{/* <Route
            path="/dashboard"
            element={<Dashboard onFilterChange={handleFilterChange} />}
          /> */}
{/* <Route
            path="/mumeneen"
            element={
              <Mumeneen
                selectedSector={selectedSector}
                selectedSubSector={selectedSubSector}
                selectedYear={selectedYear}
                onFilterChange={handleFilterChange}
                onResetFilters={resetFilters}
              />
            }
          /> */}
{/* <Route path="/mumeneen/:id" element={<MumeneenDetails />} /> */ }
{/* </Routes>
      </Router> */}